module.exports = __webpack_public_path__ + "6961d8455de2e247d2560d3e27e5bc9a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/holiday-sweater.png
// module id = 1859
// module chunks = 0